<template>
  <div class="saddle-step-one">
    <h3>Mesures patient</h3>
    <v-layout justify-space-around>
      <v-flex
        sm5
        mb-12
        mt-6
        class="left-schema"
      >
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_selle_1a.svg">
            <v-text-field
              v-model="form.a"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) A"
              :class="{ error: errors.has('(Schéma) A') }"
              outlined
              type="number"
              style="top: 20.3%;left: 0.2%;"
              height="100%"
            />
            <v-text-field
              v-model="form.b"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) B"
              :class="{ error: errors.has('(Schéma) B') }"
              outlined
              type="number"
              style="top: 33.3%;left: 0.2%;"
              height="100%"
            />
            <v-text-field
              v-model="form.c"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) C"
              :class="{ error: errors.has('(Schéma) C') }"
              outlined
              type="number"
              style="top: 91.8%;left: 39.8%;"
              height="100%"
            />
          </div>
        </div>
      </v-flex>

      <v-flex
        sm5
        mb-12
        mt-6
        class="right-schema"
      >
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_selle_1b.svg">
            <v-text-field
              v-model="form.d"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) D"
              :class="{ error: errors.has('(Schéma) D') }"
              outlined
              type="number"
              style="top: 16.4%;left: 0.1%;"
              height="100%"
            />
            <v-text-field
              v-model="form.e"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) E"
              :class="{ error: errors.has('(Schéma) E') }"
              outlined
              type="number"
              style="top: 34.6%;left: 0.1%;"
              height="100%"
            />
            <v-text-field
              v-model="form.f"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) F"
              :class="{ error: errors.has('(Schéma) F') }"
              outlined
              type="number"
              style="top: 22.8%;left: 80.3%;"
              height="100%"
            />
            <v-text-field
              v-model="form.g"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) G"
              :class="{ error: errors.has('(Schéma) G') }"
              outlined
              type="number"
              style="top: 36.7%;left: 80.3%;"
              height="100%"
            />
            <v-text-field
              v-model="form.h"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma) H"
              :class="{ error: errors.has('(Schéma) H') }"
              outlined
              type="number"
              style="top: 53.2%;left: 80.3%;"
              height="100%"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-switch
      v-model="form.idc_chassis"
      hide-details
      label="Support / Chassis :"
      class="ma-0 title"
      @change="clearChassisFields"
    />
    <v-layout
      justify-space-between
      wrap
    >
      <v-flex sm6>
        <v-radio-group
          v-model="form.chassis_existence"
          row
          :disabled="!form.idc_chassis"
        >
          <v-radio
            label="Nouveau"
            value="NEW"
          />
          <v-radio
            label="Existant"
            value="EXISTING"
          />
        </v-radio-group>
      </v-flex>

      <v-flex sm6>
        <v-radio-group
          v-model="form.chassis_position"
          row
          :disabled="!form.idc_chassis"
        >
          <v-radio
            label="En atelier"
            value="WORKSHOP"
          />
          <v-radio
            label="Chez le patient"
            value="PATIENTS_HOME"
          />
        </v-radio-group>
      </v-flex>

      <v-flex>
        <v-layout
          justify-space-between
          wrap
        >
          <v-flex sm4>
            <p class="mb-2">
              Albatros:
            </p>
            <v-select
              v-model="form.chassis_albatros"
              :items="dropdowns.chassis_albatros"
              item-text="label"
              item-value="value"
              label="PM :"
              filled
              clearable
              :disabled="!form.idc_chassis"
            />
          </v-flex>
          <v-flex sm4>
            <p class="mb-2">
              Albrider :
            </p>
            <v-select
              v-model="form.chassis_albrider"
              :items="dropdowns.chassis_albrider"
              item-text="label"
              item-value="value"
              label="Taille :"
              filled
              clearable
              :disabled="!form.idc_chassis"
            />
          </v-flex>
          <v-flex sm4>
            <v-text-field
              v-model="form.chassis_other"
              class="mt-7"
              label="Autre"
              hide-details
              outlined
              maxlength="15"
              clearable
              :disabled="!form.idc_chassis"
            />
          </v-flex>

          <v-flex sm6>
            <v-layout class="color-select">
              <v-select
                v-model="form.chassis_color_id"
                :items="seatColors"
                item-text="label"
                item-value="id"
                label="Couleur chassis :"
                filled
                clearable
                :disabled="!form.idc_chassis"
              />
              <template v-if="previewSeatColor">
                <v-flex
                  v-if="previewSeatColor.texture == 'TEXTURE'"
                  class="preview"
                  style="width: 35px; height: 35px"
                >
                  <img
                    :src="previewSeatColor.image"
                    style="width: 100%; height:100%"
                    alt
                  >
                </v-flex>
                <v-flex
                  v-else-if="previewSeatColor.texture == 'COLOR'"
                  class="preview"
                  :style="{
                    'background-color': previewSeatColor.rgb_code
                  }"
                />
              </template>
            </v-layout>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              v-model="form.chassis_number"
              label="N° de séries"
              maxlength="15"
              outlined
              clearable
              :disabled="!form.idc_chassis"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SeatStepOne",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      seatColors: "colors/getSEATType",
      dropdowns: "dropdowns/getSeatOptions"
    }),

    // Returns colors hex code for seat color preview
    previewSeatColor() {
      return this.seatColors.find(
        color => color.id == this.form.chassis_color_id
      );
    }
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear chassis fields
    clearChassisFields() {
      this.form.chassis_existence = null;
      this.form.chassis_position = null;
      this.form.chassis_albatros = null;
      this.form.chassis_albrider = null;
      this.form.chassis_color_id = null;
      this.form.chassis_other = null;
      this.form.chassis_number = null;
    }
  }
};
</script>

<style lang="scss">
.saddle-step-one {
  .left-schema {
    .content {
      display: flex;
      .img-container {
        position: relative;
        display: inline-block;
        margin: auto;
        img {
          height: 100%;
          width: 100%;
          // min-width: 800px;
          @media (max-width: 800px) {
            min-width: auto;
          }
        }
        .v-input {
          position: absolute;
          width: 29.6%;
          height: 6.4%;
          @media (max-width: 800px) {
            height: 6.4%;
          }
          .v-input__control {
            height: 100%;
            .v-input__slot {
              min-height: auto;
            }
          }
        }
      }
    }
  }
  .right-schema {
    .content {
      display: flex;
      .img-container {
        position: relative;
        display: inline-block;
        margin: auto;
        img {
          height: 100%;
          width: 100%;
          // min-width: 800px;
          @media (max-width: 800px) {
            min-width: auto;
          }
        }
        .v-input {
          position: absolute;
          width: 19.6%;
          height: 6.4%;
          @media (max-width: 800px) {
            height: 6.4%;
          }
          .v-input__control {
            height: 100%;
            .v-input__slot {
              min-height: auto;
            }
          }
        }
      }
    }
  }
}
</style>
